define('core/config',[],function () {
    'use strict';

    // These should be collected from the server
    var origin = window.location.origin;

    // configure next-core
    return {
        urls: {
            avatar: {
                generic: 'https://c.disquscdn.com/images/noavatar92.png',
            },
            api: origin + '/api/3.0/',
            apiSettings: origin + '/users/self/',
            login: origin + '/next/login/',
            oauth: {
                twitter: origin + '/_ax/twitter/begin/',
                google: origin + '/_ax/google/begin/',
                facebook: origin + '/_ax/facebook/begin/',
            },
            oauthDestroy: function (service) {
                return origin + '/_ax/' + service + '/unmerge/';
            },
            oauthStatus: function (service) {
                return origin + '/_ax/' + service + '/merged/';
            },
            userDelete: origin + '/auth/json/user_delete/',
            verifyEmail: origin + '/next/verify/',
        },
        keys: {
            api: 'E8Uh5l5fHZ6gD8U3KycjAIAk46f68Zw7C6eW8WSjZvCLXebZ7p0r1yrYDrLilk2F',
        },

        // IMPORTANT: If you change this, you must update the embed, marketing, and publisher-admin's config
        // or else the counts will be out of sync.
        feedApiVersion: '12',
        debug: false,
    };
});

